/**
 * @generated SignedSource<<4ca6c2a0ba179a389931392a013b83ba>>
 * @relayHash 54a5fc6e7c98e56377548628613e2156
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e4a2c4d0a490451b623e1067c2f4e785d8fb5ad621fe59faff5fdb574b5299b4

import type { ConcreteRequest } from 'relay-runtime';
export type ExternalWhiteboardTokenQuery$variables = {
  shareToken: string;
};
export type ExternalWhiteboardTokenQuery$data = {
  readonly entitlements: {
    readonly whiteboardFeatures: {
      readonly smartConnectors: {
        readonly isEntitled: boolean;
      } | null;
      readonly smartSections: {
        readonly isEntitled: boolean;
      } | null;
    } | null;
  } | null;
  readonly externalCanvasToken: {
    readonly token: string;
  } | null;
  readonly externalContentMediaSession: {
    readonly accessTokens: {
      readonly readOnlyToken: {
        readonly value: string;
      } | null;
      readonly readWriteToken: {
        readonly value: string;
      } | null;
    };
    readonly configuration: {
      readonly fileStoreUrl: string;
    };
  } | null;
};
export type ExternalWhiteboardTokenQuery = {
  response: ExternalWhiteboardTokenQuery$data;
  variables: ExternalWhiteboardTokenQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "shareToken"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "shareToken",
    "variableName": "shareToken"
  }
],
v2 = [
  {
    "kind": "ScalarField",
    "name": "value"
  }
],
v3 = [
  {
    "kind": "ScalarField",
    "name": "isEntitled"
  }
],
v4 = [
  {
    "args": (v1/*: any*/),
    "concreteType": "CanvasToken",
    "kind": "LinkedField",
    "name": "externalCanvasToken",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "token"
      }
    ]
  },
  {
    "args": (v1/*: any*/),
    "concreteType": "ContentMediaSession",
    "kind": "LinkedField",
    "name": "externalContentMediaSession",
    "plural": false,
    "selections": [
      {
        "concreteType": "MediaAccessTokens",
        "kind": "LinkedField",
        "name": "accessTokens",
        "plural": false,
        "selections": [
          {
            "concreteType": "MediaToken",
            "kind": "LinkedField",
            "name": "readOnlyToken",
            "plural": false,
            "selections": (v2/*: any*/)
          },
          {
            "concreteType": "MediaToken",
            "kind": "LinkedField",
            "name": "readWriteToken",
            "plural": false,
            "selections": (v2/*: any*/)
          }
        ]
      },
      {
        "concreteType": "MediaConfiguration",
        "kind": "LinkedField",
        "name": "configuration",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "fileStoreUrl"
          }
        ]
      }
    ]
  },
  {
    "concreteType": "Entitlements",
    "kind": "LinkedField",
    "name": "entitlements",
    "plural": false,
    "selections": [
      {
        "concreteType": "WhiteboardFeatures",
        "kind": "LinkedField",
        "name": "whiteboardFeatures",
        "plural": false,
        "selections": [
          {
            "concreteType": "SmartConnectorsFeature",
            "kind": "LinkedField",
            "name": "smartConnectors",
            "plural": false,
            "selections": (v3/*: any*/)
          },
          {
            "concreteType": "SmartSectionsFeature",
            "kind": "LinkedField",
            "name": "smartSections",
            "plural": false,
            "selections": (v3/*: any*/)
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ExternalWhiteboardTokenQuery",
    "selections": (v4/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ExternalWhiteboardTokenQuery",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "54a5fc6e7c98e56377548628613e2156",
    "id": "e4a2c4d0a490451b623e1067c2f4e785d8fb5ad621fe59faff5fdb574b5299b4",
    "metadata": {},
    "name": "ExternalWhiteboardTokenQuery",
    "operationKind": "query",
    "text": "query ExternalWhiteboardTokenQuery($shareToken:String!){externalCanvasToken(shareToken:$shareToken){token},externalContentMediaSession(shareToken:$shareToken){accessTokens{readOnlyToken{value},readWriteToken{value}},configuration{fileStoreUrl}},entitlements{whiteboardFeatures{smartConnectors{isEntitled},smartSections{isEntitled}}}}"
  }
};
})();

(node as any).hash = "e61a3d3ef94ce6729beda61305e291be";

export default node;
